import axios from "axios"
import * as env from "../constants/env"


/* REQUEST — EVERY ELECTRON ROUTE IS MOUNTED UNDER THE KEY OF ITS GAME */
const send = (gameKey, route, data) => {

    /* Fields */
    const uri = `${env.gamepoint}${gameKey}/${route}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    /* Send Request */
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}


/* TABLE OF THE PAGE */
export const table = (gameKey, data) => send(gameKey, "game/table", data)

/* ROUNDS LIST */
export const games = (gameKey, data) => send(gameKey, "game/list", data)

/* ROUND VIEW */
export const game = (gameKey, data) => send(gameKey, "game/get", data)

/* CREDIT / REFUND */
export const credit = (gameKey, data) => send(gameKey, "game/credit", data)

/* END GAME */
export const endGame = (gameKey, data) => send(gameKey, "game/end-game", data)

/* STATISTICS */
export const statistics = (gameKey, data) => send(gameKey, "statistic/get", data)

/* PERIOD STATISTICS */
export const periodStatistics = (gameKey, data) => send(gameKey, "statistic/period", data)
